/**
 * Sets a cookie with a specified key, value, and expiry time in hours.
 *
 * @param {string} key - The name of the cookie.
 * @param {string} value - The value of the cookie.
 * @param {number} expiry - Expiry time in hours.
 */
export const setCookie = (key, value, expiry) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + expiry * 60 * 60 * 1000); // Convert hours to milliseconds
    document.cookie = `${key}=${value};expires=${expires.toUTCString()};path=/`;
};

/**
 * Retrieves the value of a cookie by its key.
 *
 * @param {string} key - The name of the cookie.
 * @return {string | null} - The value of the cookie, or null if not found.
 */
export const getCookie = (key) => {
    const keyValue = document.cookie.match(`(^|;) ?${key}=([^;]*)(;|$)`);
    return keyValue ? keyValue[2] : false;
};

/**
 * Deletes a cookie by its key.
 *
 * @param {string} key - The name of the cookie.
 */
export const deleteCookie = (key) => {
    const keyValue = getCookie(key);
    if (keyValue !== null) {
        setCookie(key, '', -1); // Expiry set to -1 hours to delete the cookie
    }
};